var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"csv-download"},[_c('el-button',{attrs:{"type":_vm.type,"disabled":_vm.isDisabled},on:{"click":_vm.downloadClick}},[_c('i',{staticClass:"mdi mdi-download",class:{ 'mr-0': !_vm.text }}),_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }